export default __webpack_public_path__ + "static/media/1688.e296055e.png";